import { render, staticRenderFns } from "./AppActivitiesList.vue?vue&type=template&id=1b9086fc&scoped=true&"
import script from "./AppActivitiesList.vue?vue&type=script&lang=js&"
export * from "./AppActivitiesList.vue?vue&type=script&lang=js&"
import style0 from "./AppActivitiesList.vue?vue&type=style&index=0&id=1b9086fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9086fc",
  null
  
)

export default component.exports